import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import { matches } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/mobile-verification.scss';

const BACKSPACE_KEY = 8;
const LEFT_ARROW_KEY = 37;
const UP_ARROW_KEY = 38;
const RIGHT_ARROW_KEY = 39;
const DOWN_ARROW_KEY = 40;

Component('tr-mobile-verification', {
  mixins: [eventListenerMixin],

  properties: {
    smsCodeSended: {
      type: Boolean,
      default: false,
      observer(value) {
        this.namespacedTrigger('smsCodeSended', { detail: value });
      },
    },

    countdown: {
      type: Number,
      default: 60,
      observer: 'countdownChanged',
    },
  },

  connected() {
    this.$jq = $(this);
    this.form = this.querySelector('form');
    this.countryCodeInput = this.querySelector('.country-select');
    this.mobileNumberInput = this.querySelector('.mobile-input');
    this.countdownText = this.querySelector('.countdown .second');

    this.listenTo(this.form, 'submit', this.handleFormSubmit.bind(this));
    this.listenTo(this.querySelector('.link-input-mobile'), {
      click: () => {
        this.smsCodeSended = false;
        this.stopCountdown();
        this.focusMobileInput();
      },
    });

    this.$jq.on('ajax:beforeSend', this.hideFormFieldErrors.bind(this))
      .on('ajax:complete', 'form', this.handleFormSubmitted.bind(this))
      .on('ajax:success', 'form', this.handleFormSubmitSuccess.bind(this));

    this.initSmsCodeInput();
    this.addSmsCodeRequestHooks();
  },

  disconnected() {
    this.$jq.off();
    this.stopListening();
  },

  addSmsCodeRequestHooks() {
    this.$jq
      .on(
        'ajax:beforeSend',
        '.request-sms-code-button, .request-sms-code-link',
        this.beforeRequestSmsCode.bind(this),
      )
      .on(
        'ajax:success',
        '.request-sms-code-button, .request-sms-code-link',
        this.requestSmsCodeSuccess.bind(this),
      );
  },

  initSmsCodeInput() {
    this.smsCodeInput = this.querySelector('.sms-code-input');
    this.smsCodeInputs = [
      ...this.querySelectorAll('.sms-code-field input[type="number"]'),
    ];

    this.listenTo(this.querySelector('.sms-code-field'), {
      input: this.handleSmsCodeInputChange.bind(this),
      keydown: this.handleSmsCodeInputKeydown.bind(this),
      wheel: event => event.preventDefault(),
    });

    this.smsCodeInputs.forEach((input) => {
      this.listenTo(input, 'focus', () => input.select());
    });
  },

  focusMobileInput() {
    if (this.mobileNumberInput) this.mobileNumberInput.focus();
  },

  handleFormSubmit(event) {
    if (!this.smsCodeSended) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  },

  handleFormSubmitted(event) {
    if (matches(event.target, 'form.tr-form')) this.verifying = false;
  },

  handleFormSubmitSuccess(event, result) {
    if (!matches(event.target, 'form.tr-form')) return;

    if (result.success) {
      this.namespacedTrigger('verified', {
        detail: { mobile: this.mobile },
      });
    } else {
      const [{ msg: errorMessage }] = result.errors;
      this.showFormInputError('sms-code', errorMessage);
    }
  },

  beforeRequestSmsCode(event, xhr, settings) {
    const data = $.param({
      mobile_verification_request: {
        mobile_country_code: this.countryCodeInput.value,
        mobile_number: this.mobileNumberInput.value,
      },
    });

    // eslint-disable-next-line no-param-reassign
    settings.data += `&${decodeURIComponent(data)}`;
  },

  requestSmsCodeSuccess(event, result) {
    this.clearSmsCodes();

    if (result.success) {
      const { mobile } = result;
      this.querySelector(
        '.form-input-sms-code-container .title .mobile',
      ).textContent = mobile;

      this.mobile = mobile;
      this.smsCodeSended = true;
      this.selectSmsCodeInput(0);
      this.startCountdown();
    } else {
      const [{ msg: errorMessage }] = result.errors;
      this.showFormInputError('mobile', errorMessage);
    }
  },

  startCountdown() {
    this.stopCountdown();

    this.countdown = 60;

    this.countdownTimer = setInterval(() => {
      this.countdown -= 1;
      if (this.countdown === 0) this.stopCountdown();
    }, 1000);
  },

  stopCountdown() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }

    if (this.countdown !== 0) this.countdown = 0;
  },

  countdownChanged(count) {
    this.countdownText.textContent = count;
  },

  checkIfShouldSubmit() {
    const smsCode = this.smsCodeInput.value;
    if (smsCode.length !== 4 || this.verifying) return;

    this.verifying = true;
    $(this.form).trigger('submit');
  },

  handleSmsCodeInputChange(event) {
    const fullValue = event.target.value.match(/\d{0,4}/)[0];
    let index = parseInt(event.target.dataset.index, 10);

    if (!fullValue) {
      this.smsCodeInputs[index].value = '';
      this.syncSmsCodeValue();
      return;
    }

    if (fullValue.length === 1) {
      this.smsCodeInputs[index].value = fullValue;
    } else {
      fullValue.split('').forEach((value, idx) => {
        const input = this.smsCodeInputs[idx];
        if (input) input.value = value;
        index = idx;
      });
    }

    this.syncSmsCodeValue();
    this.selectSmsCodeInput(index + 1);
    if (index >= 3) this.checkIfShouldSubmit();
  },

  handleSmsCodeInputKeydown(event) {
    const index = parseInt(event.target.dataset.index, 10);

    switch (event.keyCode) {
      case BACKSPACE_KEY:
        event.preventDefault();
        this.deleteSmsCodeAt(index);
        break;
      case LEFT_ARROW_KEY:
        event.preventDefault();
        this.selectSmsCodeInput(index - 1);
        break;
      case RIGHT_ARROW_KEY:
        event.preventDefault();
        this.selectSmsCodeInput(index + 1);
        break;
      case UP_ARROW_KEY:
      case DOWN_ARROW_KEY:
        event.preventDefault();
        break;
      default:
        break;
    }
  },

  deleteSmsCodeAt(index) {
    const input = this.smsCodeInputs[index];
    if (input.value) {
      input.value = '';
      this.syncSmsCodeValue();
    } else {
      this.selectSmsCodeInput(index - 1);
    }
  },

  selectSmsCodeInput(index) {
    const input = this.smsCodeInputs[index];
    if (input) {
      input.focus();
      input.select();
    }
  },

  clearSmsCodes() {
    this.smsCodeInputs.forEach((input) => {
      // eslint-disable-next-line no-param-reassign
      input.value = '';
    });
    this.smsCodeInput.value = '';
  },

  syncSmsCodeValue() {
    this.smsCodeInput.value = this.smsCodeInputs.map(input => input.value).join('');
  },

  showFormInputError(inputType, errorMessage) {
    const field = this.querySelector(`.form-input-${inputType}-container .tr-form-input`);
    const errorText = field.querySelector('.mdc-text-field-helper-text');
    errorText.textContent = errorMessage;
    field.classList.add('invalid');
  },

  hideFormFieldErrors() {
    [...this.querySelectorAll('.tr-form-input.invalid')].forEach((field) => {
      const errorText = field.querySelector('.mdc-text-field-helper-text');
      errorText.textContent = '';
      field.classList.remove('invalid');
    });
  },
});
